//router reducers
import history from '../utils/history.util';
import {connectRouter, RouterState,} from 'connected-react-router';
import { Reducer } from 'redux';
import { LocationState } from 'history';
// app reducers
import authReducer from './ActionReducers/auth.actionreducer';
import bannerReducer from './ActionReducers/banner.actionreducer';
import menuReducer from './ActionReducers/menu.actionreducer';
import newsReducer from './ActionReducers/news.actionreducer';
import galleryReducer from './ActionReducers/gallery.actionreducer';
import noticeReducer from './ActionReducers/notice.actionreducer';
import pressReleaseReducer from './ActionReducers/pressReleaseDownloads.actionreducer';
import BannerReducer from './ActionReducers/branch.actionreducer';
import FaqReducer from './ActionReducers/faq.actionreducer';
import searchReducer from './ActionReducers/search.actionreducer';
import customizerReducer from './ActionReducers/customizer.actionreducer';
import translationReducer from './ActionReducers/translation.actionreducer';

const reducers = {
  router:connectRouter(history) as  Reducer<RouterState<LocationState>>,
  auth:authReducer,
  banner:bannerReducer,
  menu:menuReducer,
  news:newsReducer,
  gallery:galleryReducer,
  notice:noticeReducer,
  pressrelease:pressReleaseReducer,
  branch:BannerReducer,
  faq:FaqReducer,
  search:searchReducer,
  customizer:customizerReducer,
  translation:translationReducer
};

export default reducers;